export const videos = [
  {
    id: "city-night-comedy",
    title: "城市夜归人的爆笑日常",
    category: "entertainment",
    categoryName: "娱乐",
    tags: ["funny", "original", "short"],
    region: "中国大陆",
    duration: 252,
    durationLabel: "4:12",
    uploadDate: "2026-10-08",
    views: 1284000,
    rating: 4.6,
    cover:
      "https://readdy.ai/api/search-image?query=comedy%20creator%20laughing%20in%20a%20cozy%20modern%20apartment%20at%20night%20with%20warm%20string%20lights%20and%20city%20window%20view%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-01&orientation=landscape",
    author: "夜归小王",
    description:
      "加班到深夜的城市打工人，用一个个真实又荒诞的片段记录下班路上的爆笑瞬间。本期节目从地铁末班车讲到深夜便利店，把平凡的通勤路变成了一场轻松喜剧。",
  },
  {
    id: "music-festival-live",
    title: "夏日音乐节现场直击",
    category: "entertainment",
    categoryName: "娱乐",
    tags: ["hot", "original", "hd"],
    region: "中国大陆",
    duration: 398,
    durationLabel: "6:38",
    uploadDate: "2026-10-06",
    views: 2350000,
    rating: 4.8,
    cover:
      "https://readdy.ai/api/search-image?query=energetic%20crowd%20enjoying%20an%20outdoor%20summer%20music%20festival%20stage%20at%20dusk%20with%20warm%20stage%20lights%20and%20confetti%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-02&orientation=landscape",
    author: "Live现场",
    description:
      "带你回到那个夏天的音乐节现场，从傍晚的暖场到夜幕降临的全场大合唱。镜头记录下灯光、人浪与欢呼，把最炸裂的现场氛围一次呈现给你。",
  },
  {
    id: "standup-show",
    title: "单口喜剧专场精选",
    category: "entertainment",
    categoryName: "娱乐",
    tags: ["funny", "hot"],
    region: "中国大陆",
    duration: 725,
    durationLabel: "12:05",
    uploadDate: "2026-09-28",
    views: 1860000,
    rating: 4.7,
    cover:
      "https://readdy.ai/api/search-image?query=stand-up%20comedy%20stage%20with%20a%20microphone%20stand%20and%20spotlight%20in%20a%20small%20independent%20theater%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-03&orientation=landscape",
    author: "包袱铺子",
    description:
      "一场关于生活、租房与职场的单口喜剧专场。演员用密集的段子把日常的烦恼讲成笑点，全场笑声不断，适合在忙碌之后放松心情。",
  },
  {
    id: "morning-routine",
    title: "高效晨间生活方式",
    category: "life",
    categoryName: "生活",
    tags: ["tutorial", "short"],
    region: "日韩",
    duration: 320,
    durationLabel: "5:20",
    uploadDate: "2026-10-09",
    views: 960000,
    rating: 4.5,
    cover:
      "https://readdy.ai/api/search-image?query=sunlit%20modern%20bedroom%20morning%20routine%20with%20coffee%20cup%20and%20green%20plant%20on%20a%20wooden%20table%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-04&orientation=landscape",
    author: "慢生活研究所",
    description:
      "从清晨的第一缕阳光开始，用一套可复制的晨间流程让你的一天更有秩序。包含起床、运动、早餐与计划安排，简单易学，坚持一周就能感受到变化。",
  },
  {
    id: "home-organization",
    title: "小户型收纳改造指南",
    category: "life",
    categoryName: "生活",
    tags: ["tutorial", "original"],
    region: "中国大陆",
    duration: 527,
    durationLabel: "8:47",
    uploadDate: "2026-10-04",
    views: 742000,
    rating: 4.6,
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20small%20apartment%20storage%20makeover%20with%20tidy%20shelves%20and%20soft%20neutral%20tones%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-05&orientation=landscape",
    author: "收纳小分队",
    description:
      "在有限的空间里塞下更多生活。视频完整展示了一个 45 平米小户型的收纳改造过程，从测量、分区到上墙收纳，每一处都给出可落地的方案。",
  },
  {
    id: "pet-cat-daily",
    title: "橘猫的快乐一天",
    category: "life",
    categoryName: "生活",
    tags: ["pets", "funny", "original"],
    region: "中国大陆",
    duration: 185,
    durationLabel: "3:05",
    uploadDate: "2026-10-11",
    views: 1490000,
    rating: 4.9,
    cover:
      "https://readdy.ai/api/search-image?query=orange%20tabby%20cat%20playing%20with%20a%20toy%20in%20a%20bright%20cozy%20living%20room%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-06&orientation=landscape",
    author: "喵星观察员",
    description:
      "一只叫豆豆的橘猫，从早上的赖床、中午的加餐到晚上的捣乱，全程高能。看完这份猫生日程，你大概会明白什么叫真正的快乐。",
  },
  {
    id: "english-pronunciation",
    title: "零基础英语发音入门",
    category: "education",
    categoryName: "教育",
    tags: ["tutorial", "short"],
    region: "欧美",
    duration: 930,
    durationLabel: "15:30",
    uploadDate: "2026-10-02",
    views: 688000,
    rating: 4.7,
    cover:
      "https://readdy.ai/api/search-image?query=young%20teacher%20explaining%20english%20pronunciation%20beside%20a%20whiteboard%20in%20a%20bright%20classroom%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-07&orientation=landscape",
    author: "口语加油站",
    description:
      "零基础也能跟着读。课程从最基础的元音和辅音讲起，配合口型示范与跟读练习，帮助你用正确的发音开始学英语，打好口语第一步。",
  },
  {
    id: "math-thinking",
    title: "数学思维启蒙课",
    category: "education",
    categoryName: "教育",
    tags: ["tutorial", "family"],
    region: "中国大陆",
    duration: 1102,
    durationLabel: "18:22",
    uploadDate: "2026-09-30",
    views: 512000,
    rating: 4.6,
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20math%20learning%20materials%20and%20geometric%20shapes%20on%20a%20desk%20in%20a%20study%20room%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-08&orientation=landscape",
    author: "启蒙课堂",
    description:
      "用图形和游戏带孩子建立数学思维。课程通过拼搭、分类与规律推理，让孩子在动手中理解数量关系，培养对数学的兴趣。",
  },
  {
    id: "science-experiment",
    title: "家庭趣味科学实验",
    category: "education",
    categoryName: "教育",
    tags: ["tutorial", "family", "short"],
    region: "中国大陆",
    duration: 555,
    durationLabel: "9:15",
    uploadDate: "2026-10-07",
    views: 604000,
    rating: 4.8,
    cover:
      "https://readdy.ai/api/search-image?query=fun%20home%20science%20experiment%20with%20beakers%20and%20colorful%20liquids%20on%20a%20kitchen%20table%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-09&orientation=landscape",
    author: "科学小实验",
    description:
      "在家就能做的小实验合集，材料随手可得。每个实验都附上原理讲解，让孩子在惊呼中理解浮力、密度与化学反应，安全又好玩。",
  },
  {
    id: "ai-future",
    title: "人工智能如何改变生活",
    category: "tech",
    categoryName: "科技",
    tags: ["hot", "documentary", "hd"],
    region: "欧美",
    duration: 700,
    durationLabel: "11:40",
    uploadDate: "2026-10-10",
    views: 1720000,
    rating: 4.8,
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20digital%20network%20and%20glowing%20data%20visualization%20in%20a%20dark%20technology%20backdrop%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-10&orientation=landscape",
    author: "科技前哨",
    description:
      "从日常出行到医疗诊断，人工智能正悄悄渗透进生活的每个角落。本期用通俗的语言梳理 AI 的发展脉络，并展望它未来可能带来的改变。",
  },
  {
    id: "drone-review",
    title: "旗舰航拍无人机评测",
    category: "tech",
    categoryName: "科技",
    tags: ["tutorial", "hd"],
    region: "中国大陆",
    duration: 475,
    durationLabel: "7:55",
    uploadDate: "2026-10-05",
    views: 823000,
    rating: 4.6,
    cover:
      "https://readdy.ai/api/search-image?query=professional%20camera%20drone%20hovering%20above%20a%20scenic%20mountain%20valley%20in%20golden%20hour%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-11&orientation=landscape",
    author: "数码实测",
    description:
      "从画质、续航到避障，全面评测今年最值得关注的旗舰航拍无人机。实拍样张与飞行测试同步呈现，帮你在下单前看清它的真实表现。",
  },
  {
    id: "smart-home",
    title: "全屋智能家居搭建",
    category: "tech",
    categoryName: "科技",
    tags: ["tutorial", "original"],
    region: "中国大陆",
    duration: 798,
    durationLabel: "13:18",
    uploadDate: "2026-09-29",
    views: 561000,
    rating: 4.7,
    cover:
      "https://readdy.ai/api/search-image?query=modern%20smart%20home%20living%20room%20with%20ambient%20lighting%20and%20connected%20devices%20in%20the%20evening%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-12&orientation=landscape",
    author: "智能生活家",
    description:
      "从灯光、窗帘到影音与安防，手把手演示如何把一套普通住宅改造成全屋智能。包含前期规划、设备选型与场景联动的完整流程。",
  },
  {
    id: "piano-cover",
    title: "钢琴改编治愈系纯音乐",
    category: "music",
    categoryName: "音乐",
    tags: ["hd", "original"],
    region: "日韩",
    duration: 285,
    durationLabel: "4:45",
    uploadDate: "2026-10-03",
    views: 934000,
    rating: 4.9,
    cover:
      "https://readdy.ai/api/search-image?query=grand%20piano%20in%20a%20warm%20sunlit%20studio%20with%20sheet%20music%20and%20soft%20bokeh%20background%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-13&orientation=landscape",
    author: "琴键旅人",
    description:
      "把熟悉的旋律改编成钢琴独奏，配上简单的环境音，适合在午后或深夜安静聆听。闭上眼，让音符把一天的情绪轻轻抚平。",
  },
  {
    id: "folk-song",
    title: "民谣吉他弹唱合集",
    category: "music",
    categoryName: "音乐",
    tags: ["original", "short"],
    region: "中国大陆",
    duration: 370,
    durationLabel: "6:10",
    uploadDate: "2026-09-27",
    views: 452000,
    rating: 4.5,
    cover:
      "https://readdy.ai/api/search-image?query=acoustic%20guitar%20resting%20beside%20a%20window%20with%20warm%20afternoon%20light%20in%20a%20rustic%20room%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-14&orientation=landscape",
    author: "木吉他手",
    description:
      "一把木吉他，几首耐听的民谣。视频收录了多首经典弹唱曲目，附上和弦走向提示，喜欢弹吉他的朋友也可以跟着一起哼唱。",
  },
  {
    id: "marathon-city",
    title: "城市马拉松精彩瞬间",
    category: "sports",
    categoryName: "体育",
    tags: ["hot", "hd"],
    region: "欧美",
    duration: 335,
    durationLabel: "5:35",
    uploadDate: "2026-10-08",
    views: 726000,
    rating: 4.6,
    cover:
      "https://readdy.ai/api/search-image?query=runners%20crossing%20a%20city%20marathon%20finish%20line%20with%20a%20cheering%20crowd%20on%20a%20sunny%20street%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-15&orientation=landscape",
    author: "跑者视野",
    description:
      "镜头跟随跑者穿过城市的街道与地标，记录下冲刺时刻的汗水与欢呼。无论你是否参赛，都能从中感受到坚持到底的那份力量。",
  },
  {
    id: "basketball-highlights",
    title: "街头篮球高光集锦",
    category: "sports",
    categoryName: "体育",
    tags: ["hot", "short"],
    region: "欧美",
    duration: 298,
    durationLabel: "4:58",
    uploadDate: "2026-10-01",
    views: 1105000,
    rating: 4.7,
    cover:
      "https://readdy.ai/api/search-image?query=street%20basketball%20player%20dunking%20on%20an%20outdoor%20urban%20court%20at%20sunset%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-16&orientation=landscape",
    author: "街球现场",
    description:
      "汇集本季度最精彩的街头篮球瞬间，突破、扣篮与绝杀一应俱全。配合慢镜头回放，带你重温那些让全场沸腾的高光时刻。",
  },
  {
    id: "sichuan-noodles",
    title: "正宗川味担担面教程",
    category: "food",
    categoryName: "美食",
    tags: ["cooking", "tutorial"],
    region: "中国大陆",
    duration: 612,
    durationLabel: "10:12",
    uploadDate: "2026-10-09",
    views: 897000,
    rating: 4.8,
    cover:
      "https://readdy.ai/api/search-image?query=authentic%20sichuan%20dan%20dan%20noodles%20bowl%20with%20chili%20oil%20and%20scallions%20on%20a%20rustic%20table%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-17&orientation=landscape",
    author: "川味厨房",
    description:
      "从炒制芽菜肉臊到调配红油酱汁，完整还原一碗地道担担面的做法。视频标注了每一步的火候与比例，跟着做，在家也能吃到街头老味道。",
  },
  {
    id: "bakery-bread",
    title: "手作欧包烘焙全过程",
    category: "food",
    categoryName: "美食",
    tags: ["cooking", "tutorial", "hd"],
    region: "欧美",
    duration: 760,
    durationLabel: "12:40",
    uploadDate: "2026-10-05",
    views: 634000,
    rating: 4.7,
    cover:
      "https://readdy.ai/api/search-image?query=artisan%20sourdough%20bread%20baking%20process%20with%20flour%20and%20dough%20on%20a%20wooden%20counter%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-18&orientation=landscape",
    author: "面包日记",
    description:
      "从天然酵种的培养到最终烘烤出炉，完整记录一个欧包的诞生。视频详细讲解发酵时间与整形手法，帮助新手也能烤出漂亮的开裂纹路。",
  },
  {
    id: "street-food",
    title: "夜市小吃探店vlog",
    category: "food",
    categoryName: "美食",
    tags: ["cooking", "short", "original"],
    region: "港台",
    duration: 485,
    durationLabel: "8:05",
    uploadDate: "2026-10-11",
    views: 1052000,
    rating: 4.6,
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20night%20market%20street%20food%20stall%20with%20sizzling%20skewers%20and%20warm%20lantern%20light%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-19&orientation=landscape",
    author: "逛吃小分队",
    description:
      "带你走遍夜市里最受欢迎的摊位，从烤串、臭豆腐到手工甜品，一路吃到底。视频还整理了每家摊位的招牌菜与排队建议，实用又馋人。",
  },
  {
    id: "mountain-sunrise",
    title: "徒步看山顶日出",
    category: "travel",
    categoryName: "旅行",
    tags: ["documentary", "hd"],
    region: "中国大陆",
    duration: 448,
    durationLabel: "7:28",
    uploadDate: "2026-10-10",
    views: 1280000,
    rating: 4.9,
    cover:
      "https://readdy.ai/api/search-image?query=hiker%20standing%20on%20a%20mountain%20summit%20watching%20sunrise%20above%20a%20sea%20of%20clouds%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-20&orientation=landscape",
    author: "山野行者",
    description:
      "凌晨出发，翻过最后一道山脊，只为等一场在山顶升起的日出。视频记录了整段徒步路线与云海翻涌的瞬间，也分享了装备与体力的准备建议。",
  },
  {
    id: "coastal-drive",
    title: "沿海公路自驾之旅",
    category: "travel",
    categoryName: "旅行",
    tags: ["hd", "documentary"],
    region: "欧美",
    duration: 590,
    durationLabel: "9:50",
    uploadDate: "2026-10-04",
    views: 712000,
    rating: 4.7,
    cover:
      "https://readdy.ai/api/search-image?query=scenic%20coastal%20road%20drive%20along%20cliffs%20with%20turquoise%20ocean%20and%20a%20clear%20sky%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-21&orientation=landscape",
    author: "在路上",
    description:
      "沿着海岸线一路向南，窗外是悬崖与碧海。视频串联了沿途的观景台、小镇与露营地，附上路线规划与加油补给提示，适合作为自驾参考。",
  },
  {
    id: "old-town-walk",
    title: "漫步千年古镇",
    category: "travel",
    categoryName: "旅行",
    tags: ["documentary", "short"],
    region: "中国大陆",
    duration: 382,
    durationLabel: "6:22",
    uploadDate: "2026-09-26",
    views: 498000,
    rating: 4.6,
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20water%20town%20old%20street%20with%20a%20stone%20bridge%20and%20traditional%20houses%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-22&orientation=landscape",
    author: "古巷慢行",
    description:
      "青石板路、白墙黛瓦与河上小船，构成了一幅安静的水乡画卷。视频以慢节奏带你穿行古镇的小巷，感受被时光放慢的日常。",
  },
  {
    id: "documentary-ocean",
    title: "深海纪录片：蔚蓝秘境",
    category: "travel",
    categoryName: "旅行",
    tags: ["documentary", "hd"],
    region: "欧美",
    duration: 1330,
    durationLabel: "22:10",
    uploadDate: "2026-09-25",
    views: 1456000,
    rating: 4.9,
    cover:
      "https://readdy.ai/api/search-image?query=underwater%20deep%20sea%20scene%20with%20rays%20of%20sunlight%20and%20schools%20of%20fish%20in%20blue%20water%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-23&orientation=landscape",
    author: "自然纪录组",
    description:
      "潜入阳光无法抵达的深海，探访发光的生物与奇特的珊瑚群落。这部长纪录片用高清镜头呈现海洋不为人知的一面，唤起我们对自然的敬畏。",
  },
  {
    id: "kids-cartoon",
    title: "儿童动画：小恐龙历险记",
    category: "education",
    categoryName: "教育",
    tags: ["family", "short", "original"],
    region: "中国大陆",
    duration: 344,
    durationLabel: "5:44",
    uploadDate: "2026-10-07",
    views: 812000,
    rating: 4.8,
    cover:
      "https://readdy.ai/api/search-image?query=cheerful%20cartoon%20style%20dinosaur%20character%20in%20a%20colorful%20friendly%20prehistoric%20landscape%2C%20cinematic%20film%20still%2C%20soft%20natural%20lighting%2C%20shallow%20depth%20of%20field%2C%20vivid%20color%20grading%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=800&height=450&seq=pp-vid-24&orientation=landscape",
    author: "童趣动画",
    description:
      "小恐龙奇奇第一次离开家去寻找传说中的彩虹谷。一路上的伙伴与挑战，让它学会了勇敢与分享。画面明快、语言简单，适合亲子一起观看。",
  },
];